/**
 * EVM token types
 */
export var EvmToken;
(function (EvmToken) {
    EvmToken["USDC"] = "usdc";
    EvmToken["USDT"] = "usdt";
    EvmToken["USDCE"] = "usdce";
})(EvmToken || (EvmToken = {}));
